<template>
    <div>
        <h3>申请签名： {{task.content.tip}}</h3>
        <ul>
            <li>申请人 {{task.j_sender.realname}}</li>
            <li>申请时间 {{task.insert_time}}</li>
            <li>申请公司 {{task.j_sender.company_name}}</li>
        </ul>
    </div>
</template>

<script>
    import util from '../../../libs/util';
    export default {
        name: "signature-approve",
        props: {
            task: {
                type: Object,
                handler () {

                },
                deep: true,
                immediate: true
            }
        },
        methods: {
            reject () {
                util.ajax.put('/depart/approvesignature', {
                    id: this.task.content.id,
                    sms_signature_enabled: -1,
                    sms_signature: this.task.content.tip
                })
            },
            resolve() {
                util.ajax.put('/depart/approvesignature', {
                    id: this.task.content.id,
                    sms_signature_enabled: 1,
                    sms_signature: this.task.content.tip
                })
            }
        }
    }
</script>

<style scoped>

</style>